import { inject, Injectable } from '@angular/core';
import { MBS_APP_CONFIG } from '../../../config.loader';

export abstract class ConfigurationAbstractService {
  abstract get(key: string): any;
}

@Injectable({ providedIn: 'root' })
export class ConfigurationService implements ConfigurationAbstractService {
  private readonly configuration = inject(MBS_APP_CONFIG);

  get(key: string): any {
    return this.configuration[key];
  }
}
